<template>
  <div class="home">
    <div ref="preview" class="preview">
      <div class="preview-container" v-images-loaded:on.progress="imageProgress">
        <img 
          v-for="item in categories" 
          ref="previewImg"
          :key="item.url"
          :src="require(`@/assets/home/${item.url}.jpg`)" 
          :alt="item.name">
      </div>
    </div>
    <div ref="scroll" class="scroll" :style="{ transform: `translate3D(0, -${progress.px}px, 0)` }">
      <header class=header>
        <div class="header-container">
          <h1 ref="title">Lookbook 2020</h1>
          <h2 ref="subtitle">Huu-Tai LÊ</h2>
        </div>
      </header>
      <nav class="navigation">
        <div v-for="(item, i) in categories" :key="i" class="navigation-item">
          <div class="navigation-container" :data-index="item.url">
            <router-link 
              :to="{ path: `/${item.url}` }"
              @mouseenter.native="$emit('mouse', 'hover')" 
              @mouseleave.native="$emit('mouse', 'normal')" 
              class="navigation-link">
              <h3>{{ item.name }}</h3>
              <p>Explore</p>
            </router-link>
          </div>
        </div>
      </nav>
      <footer class=footer>
        <div class="footer-container">
          <p>By Jérôme BOUTASSIME</p>
        </div>
      </footer>
    </div>
  </div>
</template>

<script>
import routes from '../routes'

export default {
  name: 'home',
  props: {
    progress: {
      type: Object
    },
    winsize: {
      type: Object
    },
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.$anime({
        targets: [vm.$refs.title, vm.$refs.subtitle],
        translateY: [-10, 0],
        opacity: [0, 1],
        duration: 1200,
        delay: vm.$anime.stagger(1000, {start: 2000}),
        easing: 'cubicBezier(0.520, 0.340, 0.005, 0.995)',
      })
    })
  },
  beforeRouteLeave (to, from , next) {
    if (to.name == 'gallery') {
      this.$anime({
        targets: [this.$refs.scroll, this.$refs.preview],
        opacity: [1, 0],
        duration: 1200,
        delay: this.$anime.stagger(600, {start: 300}),
        easing: 'cubicBezier(0.520, 0.340, 0.005, 0.995)',
        complete: () => {
          this.$emit('scrollTo', { y: 0, now: true })
          this.$emit('load', false)
          next()
        }
      })
    } else {
      next()
    }
  },
  data() {
    return {
      index: 0,
      categories: routes,
      maxImage: null,
      loadedImage: 0,
    }
  },
  watch: {
    progress({px, max}) {
      this.$refs.previewImg.map((img, i) => {
        if (px < this.winsize.height/2 || px > max - this.winsize.height/2) 
          this.index = null
        else
          if (px >= this.winsize.height/2 + this.winsize.height*i/2 && px < this.winsize.height/2 + this.winsize.height*(i+1)/2) this.index = img
      })
    },
    index(newVal, oldVal) {
      if (newVal) {
        this.$anime({
          targets: newVal,
          opacity: [0, 1],
          scale: [1.05, 1],
          duration: 1200,
          easing: 'cubicBezier(0.520, 0.340, 0.005, 0.995)'
        })
      }

      if (oldVal) {
        this.$anime({
          targets: oldVal,
          opacity: [1, 0],
          duration: 1200,
          easing: 'cubicBezier(0.520, 0.340, 0.005, 0.995)'
        })
      }
    }
  },
  computed: {
    loadedImageProgress() {
      return (this.loadedImage / this.maxImage) * 100
    }
  },
  methods: {
    imageProgress(instance, image ) {
      if (image.isLoaded) {
        this.loadedImage++
        this.maxImage = instance.images.length
        if (this.loadedImage == this.maxImage) this.$emit('load', true)
      }
    }
  },
}
</script>

<style lang="scss" scoped>
.preview {
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: none;
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 0;

  &-container {
    @extend %container;
    
    position: relative;
    height: 200px;
    overflow: hidden;

    @media screen and (min-width: 768px) {
      height: 400px;
    }

    &:after {
      z-index: 2;
      content: "";
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background-color: rgba($white, 0.3);
    }

    img {
      z-index: 0;
      opacity: 0;
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      object-fit: cover;
      transform: scale(1.2);
    }
  }
}

.header,
.footer {
  position: relative;
  z-index: 1;
  height: calc(var(--vh, 1vh) * 100);
  display: flex;
  align-items: center;
  justify-content: center;

  &-container {
    @extend %container;
    text-align: center;
  }

  h1 {
    @extend %title;
  }
  
  h2, 
  p {
     @extend %subtitle;
  }
}

.navigation {
  position: relative;
  z-index: 1;
  padding-bottom: calc(var(--vh, 1vh) * 25);

  &-item {
    height: calc(var(--vh, 1vh) * 50);
    display: flex;
    align-items: center;
    justify-content: center;
  }

  &-container {
    @extend %container;

    text-align: center;
  }

  &-link {
    text-decoration: none;
    color: $darkvanilla;
    letter-spacing: 0.5rem;

    h3 {
      font-family: 'Cinzel', serif;
      font-size: 3rem;
      line-height: 3rem;
      color: $eggshell;
    }

    p {
      @extend %subtitle;
      opacity: 0;
      transition: opacity 0.5s $ease-out;
    }

    &:hover p {
      opacity: 1;
    }
  }
}
</style>